/* tslint:disable */
import * as React from 'react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

interface SearchState {
    keyword: string,
    errorMessage: string,
    checkedTci: boolean,
    checkedWako: boolean,
    checkedNacalai: boolean,
    checkedAldrich: boolean,
    checkedHayashi: boolean,
}

const updateState = <T extends string | boolean | boolean[] | number | number[]>(key: keyof SearchState, value: T) => (
    prevState: SearchState
): SearchState => ({
    ...prevState,
    [key]: value
});

class Search extends React.Component<any, SearchState> {
    constructor(props: any) {
        super(props);
        this.state = {
            keyword: "",
            errorMessage: "",
            checkedTci: true,
            checkedWako: true,
            checkedNacalai: true,
            checkedAldrich: true,
            checkedHayashi: false,
        }
    }

    public componentDidMount(): void {
        document.title = "試薬検索支援";
    }

    private search = () => {
        const keyword = this.state.keyword;
        if (keyword === "") {
            this.setState({errorMessage: "キーワードを入力してください"});
            return;
        }
        this.setState({errorMessage: ""});
        if (this.state.checkedTci) {
            window.open("https://www.tcichemicals.com/eshop/ja/jp/catalog/list/search?searchWord=" + keyword + "&oe=UTF-8&ie=UTF-8&site=ja_jp&mode=0");
        }
        if (this.state.checkedWako) {
            window.open("https://labchem-wako.fujifilm.com/jp/product/result/product.html?fw=" + keyword);
        }
        if (this.state.checkedNacalai) {
            window.open("https://www.nacalai.co.jp/ss/ec/EC-srchAll.cfm?srchword=" + keyword);
        }
        if (this.state.checkedAldrich) {
            window.open("https://www.sigmaaldrich.com/catalog/search?term=" + keyword + "&interface=All_JA&N=0&mode=match%20partialmax&lang=ja&region=JP&focus=product");
        }
        if (this.state.checkedHayashi) {
            window.open("http://www.hpc-j.co.jp/?s=" + keyword);
        }
    };

    public render() {
        const vendorSwitch = (title: string, id: keyof SearchState) => (
            <FormControlLabel control={
                <Switch checked={this.state[id] as any as string}
                        onChange={() => this.setState(updateState(id, !this.state[id]))}
                        value={id}/>
            }
                              label={title}
            />
        );

        return (
            <div style={{marginTop: "20px", marginLeft: "20px"}}>
                <div style={{marginBottom: "20px"}}>
                    <Typography variant={"body1"}>一つの検索ボックスでまとめて複数の試薬メーカーの試薬検索ができます。</Typography>
                    <Typography variant={"caption"}>ここにないメーカーは非対応です（GETリクエストのもの限定）。</Typography>
                    <Typography variant={"caption"}>検索結果として、それぞれのメーカーの検索結果ページが新しいタブ（ウインドウ）として表示されます。</Typography>
                    <Typography variant={"caption"}>複数のメーカー商品を検索する場合、ポップアップ制限でブロックされることがあります。</Typography>
                </div>
                <form name="reagent_search" id="reagent_search">
                    <Input type="text" id="keyword"
                           placeholder="キーワードを入力"
                           value={this.state.keyword}
                           onChange={e => this.setState({keyword: e.target.value})}
                    />
                    <Button variant={"contained"} color={"primary"}
                            size={"small"} id="submit"
                            style={{marginLeft: "20px"}}
                            onClick={() => this.search()}
                            disabled={(!this.state.checkedTci && !this.state.checkedWako && !this.state.checkedNacalai && !this.state.checkedAldrich && !this.state.checkedHayashi) || this.state.keyword === ""}>検索</Button>
                    <span style={{color: "red"}}>{this.state.errorMessage}</span>
                    <div>
                        {vendorSwitch("TCI", "checkedTci")}
                        {vendorSwitch("Wako", "checkedWako")}
                        {vendorSwitch("Nacalai", "checkedNacalai")}
                        {vendorSwitch("Aldrich", "checkedAldrich")}
                        {vendorSwitch("林純薬", "checkedHayashi")}
                    </div>
                </form>
            </div>
        );
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/components/Search.tsx